import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { environment } from '../../../environments/environment';
import { AuthControlService } from '@medsurf/flat-services';

@Component({
  selector: 'medsurf-restricted-lock',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './restricted-lock.component.html',
  styleUrls: ['./restricted-lock.component.scss'],
  standalone: false
})
export class RestrictedLockComponent {
    @Input() public node: FlatModels.NodeEntityModels.NodeEntityType;
    @Input() public containerClass = '';

    shopConfig = environment.config.shop;

    constructor(
        public appSharedFacade: FlatFacades.AppSharedFacade,
        public authControlService: AuthControlService
    ) {}
}